import { checkPrivileges } from "../../Helpers";
import { USER_TYPE } from "./formDefaults";

const isSimpleUser = (user) =>
  user?.userType === USER_TYPE.USER || user?.userType === USER_TYPE.ADMIN;

export const getUserDetailTabs = ({ selectedUser, logInUser }) => [
  { value: "edit", labelKey: "sharedEdit" },
  {
    value: "user",
    labelKey: "users",
    show: selectedUser?.userType !== USER_TYPE.USER && logInUser?.userType !== USER_TYPE.DISTRIBUTOR,
  },
  {
    value: "access",
    labelKey: "access",
    show: selectedUser?.userType === USER_TYPE.SERVICE_PROVIDER,
  },
  {
    value: "unit",
    labelKey: "deviceTitle",
    show: logInUser?.userType !== USER_TYPE.DISTRIBUTOR,
  },
  { value: "vehicle", labelKey: "vehicle" },
  {
    value: "group",
    labelKey: "groups",
    show: logInUser?.userType !== USER_TYPE.DISTRIBUTOR,
  },
  { value: "dashboard", labelKey: "dashboard", show: checkPrivileges("dashboard") },
  { value: "widget", labelKey: "widgets", show: checkPrivileges("dashboard") },
  { value: "city", labelKey: "city" },
  {
    value: "role",
    labelKey: "role",
    show:
      (logInUser?.userType === USER_TYPE.OWNER ||
        logInUser?.userType === USER_TYPE.RESELLER) &&
      checkPrivileges("userUpdate"),
  },
  { value: "map", labelKey: "mapTitle", show: checkPrivileges("userUpdate") },
  { value: "changePassword", labelKey: "changePassword" },
  {
    value: "report",
    labelKey: "report",
    show:
      selectedUser?.userType !== USER_TYPE.USER &&
      checkPrivileges("userLinkRp") &&
      checkPrivileges("userUpdate") &&
      checkPrivileges("userUnlinkRp"),
  },
  {
    value: "themeSettings",
    labelKey: "themeSettings",
    show: checkPrivileges("themeChange") && !isSimpleUser(selectedUser),
  },
  {
    value: "serverSettings",
    labelKey: "serverSettings",
    show: logInUser?.userType === USER_TYPE.OWNER && !isSimpleUser(selectedUser),
  },
  {
    value: "accountUsers",
    labelKey: "accountUser",
    show:
      logInUser?.userType !== USER_TYPE.ACCOUNT_ADMIN && !isSimpleUser(selectedUser),
  },
  {
    value: "accountUnits",
    labelKey: "accountUnits",
    show: logInUser?.userType !== USER_TYPE.DISTRIBUTOR,
  },
  { value: "waslApi", labelKey: "waslApiKey", show: Boolean(logInUser?.userType) },
  {
    value: "termsAndConditions",
    labelKey: "termsAndConditions",
    show: Boolean(logInUser?.userType) && !isSimpleUser(selectedUser),
  },
  { value: "additionalEmails", labelKey: "Additional Info" },
];

export const getAccountDetailTabs = ({ selectedAccount,logInUser }) => [
  { value: "edit", labelKey: "sharedEdit" },
  { value: "monthlyTargets", labelKey: "monthlyTargets" },
  {
    value: "contractManagement",
    labelKey: "contractManagement",
    show: selectedAccount?.userType === USER_TYPE.ACCOUNT_ADMIN,
  },
  {
    value: "Invoices",
    labelKey: "Invoices",
    show: selectedAccount?.userType === USER_TYPE.ACCOUNT_ADMIN,
  },
  {
    value: "payment",
    labelKey: "Payment",
    show: selectedAccount?.userType === USER_TYPE.ACCOUNT_ADMIN,
  },
  { value: "vehicles", labelKey: "vehicles" },
  { value: "settings", labelKey: "Settings",
    show: logInUser?.roleId===-1,
   },
  { value: "syncVehicle", labelKey: "syncVehicles" },
  { value: "additionalEmails", labelKey: "Additional Emails" },
];

export const visibleTabs = (tabs) =>
  tabs.filter((tab) => tab.show !== false);
